let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fFbrC")).then(() => parcelRequire('43DFy'));